// Returns an array of x-axis tick positions. This assumes that the ticks are positioned at the same x-coordinates as markers.
export function getXTickPositions() {
  const xTicks = []
  // Select all X-axis ticks
  const lines = document.querySelectorAll('.apexcharts-xaxis-tick')

  lines.forEach((line) => {
    const x = parseFloat(line.getAttribute('x1'))
    if (!isNaN(x)) {
      xTicks.push(x)
    }
  })

  return xTicks
}

// Returns the length of the path to a specific x-coordinate.
export function getLengthToX(path, targetX, precision = 0.5) {
  const totalLength = path.getTotalLength()

  for (let len = 0; len <= totalLength; len += precision) {
    const point = path.getPointAtLength(len)
    if (point.x >= targetX) {
      return len
    }
  }

  return totalLength // fallback if targetX is beyond path bounds
}
